import { Injectable } from '@angular/core'
import { BaseService } from '../base.service'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class CoachManageService extends BaseService {
  contextPath = this.path +'/coachs'
  pathCoachContract = this.path +'/coach-contracts'
  pathCoachCertification = this.path +'/coach-certifications'
  pathCoachAchievement = this.path +'/coach-achievements'
  pathCoachTrainingProcess = this.path +'/coach-histories'

  // list Coach
  search(payload: any): Observable<any> {
    return this.get(this.contextPath, payload)
  }

  create(payload: any): Observable<any> {
    return this.post(this.contextPath, payload)
  }

  update(payload: any, coachId: number): Observable<any> {
    return this.put(this.contextPath + `/${coachId}`, payload)
  }

  deleteItem(id: any): Observable<any> {
    return this.delete(this.contextPath + `/${id}`)
  }

  getDetail(id: number): Observable<any> {
    return this.get(this.contextPath + `/${id}`, null)
  }

  // coach contract
  searchContract(payload: any): Observable<any> {
    return this.get(this.pathCoachContract, payload)
  }

  createContract(payload: any): Observable<any> {
    return this.post(this.pathCoachContract, payload)
  }

  updateContract(payload: any): Observable<any> {
    return this.put(this.pathCoachContract + `/${payload?.id}`, payload)
  }

  deleteContract(id: any): Observable<any> {
    return this.delete(this.pathCoachContract + `/${id}`)
  }

  //coach certification
  searchCertification(payload: any): Observable<any> {
    return this.get(this.pathCoachCertification, payload)
  }

  createCertification(payload: any): Observable<any> {
    return this.post(this.pathCoachCertification, payload)
  }

  updateCertification(payload: any): Observable<any> {
    return this.put(this.pathCoachCertification + `/${payload?.id}`, payload)
  }

  deleteCertification(id: any): Observable<any> {
    return this.delete(this.pathCoachCertification + `/${id}`)
  }

  //coach achievement
  searchAchievement(payload: any): Observable<any> {
    return this.get(this.pathCoachAchievement, payload)
  }

  createAchievementAchievement(payload: any): Observable<any> {
    return this.post(this.pathCoachAchievement, payload)
  }

  updateAchievement(payload: any): Observable<any> {
    return this.put(this.pathCoachAchievement + `/${payload?.id}`, payload)
  }

  deleteAchievement(id: any): Observable<any> {
    return this.delete(this.pathCoachAchievement + `/${id}`)
  }

  //coach achievement
  searchHistories(payload: any): Observable<any> {
    return this.get(this.pathCoachTrainingProcess, payload)
  }

  //export
  export(payload: any): Observable<any> {
    return this.post(this.contextPath + '/export', payload, '', { responseType: 'blob' as 'json' })
  }

  //import file mẫu
  downloadTemplateFileUser(): Observable<any> {
    return this.post(`${this.contextPath}/download-example`, null, '', { responseType: 'blob' as 'json' })
  }

  //import file
  loadFileDataUser(payload: any): Observable<any> {
    return this.post(this.contextPath + '/import', payload)
  }

}
